import { useEffect, useState } from 'react';
import { EVENTO_CONSENTIMENTO, lerConsentimento } from '@/lib/widgets/consent';

/**
 * O jogador aceitou anúncios nesta loja? Lê o que o banner guardou no mesmo
 * render em que a loja chega (um efeito leria depois, e o espaço já teria
 * sorteado sem o Google) e acompanha a resposta na hora. Recusar ou não
 * responder deixa só o anúncio próprio.
 */
export function useAceiteDeAnuncio(storeId: string | undefined): boolean {
  const [resposta, setResposta] = useState<{ storeId: string; aceito: boolean } | null>(null);

  useEffect(() => {
    if (!storeId) return;
    const ouvir = (e: Event) => {
      const detalhe = (e as CustomEvent<{ storeId: string; valor: { advertising: boolean } }>).detail;
      if (detalhe?.storeId === storeId) setResposta({ storeId, aceito: detalhe.valor.advertising === true });
    };
    window.addEventListener(EVENTO_CONSENTIMENTO, ouvir);
    return () => window.removeEventListener(EVENTO_CONSENTIMENTO, ouvir);
  }, [storeId]);

  if (!storeId) return false;
  if (resposta && resposta.storeId === storeId) return resposta.aceito;
  return lerConsentimento(storeId).valor.advertising;
}
